// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__bAkd2","content":"Consent_content__3dMfT","footer":"Consent_footer__-DvYh"};